export default [{
  path: '/view/usertime',
  name: 'usertime',
  component: () => import('@/app/user-time/UserTime'),
  meta: {
    resource: 'usertime',
    actions: ['read']
  }
}]
